module.exports = __webpack_public_path__ + "img/BlinkArt_Spear2H_Medium.6db9f828.png";